import React, { useEffect } from 'react';
import { Grid, Container, CssBaseline, makeStyles } from '@material-ui/core';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../app/rootReducer';
import { ADD_STUDENT } from '../../../constants/routes';
import { getStudentById } from '../../../slices/studentSlice';
import EnhancedEditSuperAdminProfileForm from './EnhancedEditSuperAdminProfileForm';
import { getParentByIdRefresh } from '../../../slices/parentSlice';
import { getSuperAdminByIdRefresh } from '../../../slices/superAdminSlice';

interface IEditSuperAdminProfileProps {}

const EditSuperAdminProfile: React.FC<IEditSuperAdminProfileProps> = ({}) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    counselorLoading,
    parentLoading,
    programManagerLoading,
    role,
    diagnoses,
    counselors,
    programManager,
    counselor,
    superAdmin
  } = useSelector((state: RootState) => {
    return {
      programManagerLoading: state.programManager.loading,
      counselorLoading: state.counselor.loading,
      parentLoading: state.parent.loading,
      diagnoses: state.diagnosis.diagnoses,
      counselors: state.counselor.counselors,
      role: state.auth.role,
      programManager:state.programManager.programManager,
      counselor: state.counselor.counselor,
      superAdmin:state.superAdmin.superAdmin,

    };
  }, shallowEqual);

  const user_id = localStorage.getItem('user_id');
  const userRole = localStorage.getItem('userRole');
  if(superAdmin)
  {
    localStorage.setItem('userData', JSON.stringify(superAdmin));
  }

  useEffect(() => {
    async function fetchMyAPI() {

        if(user_id)
        {
              dispatch(getSuperAdminByIdRefresh(user_id));
        }
        else
        {
          
        }
}
  
fetchMyAPI()
  return () => {};
}, []);


  let renderedForm;
  // if (!isAddStudent && student) {
  //   const {
  //     name,
  //     email,
  //     schoolName,
  //     referenceCode,
  //     address,
  //     street,
  //     city,
  //     country,
  //     postalCode,
  //     about,
  //   } = student;
  //   renderedForm = (
  //     <EnhancedEditStudentForm
  //       name={name}
  //       email={email}
  //       address={address}
  //       street={street}
  //       city={city}
  //       country={country}
  //       postalCode={postalCode}
  //       about={about}
  //     />
  //   );
  // } else {
  renderedForm = <EnhancedEditSuperAdminProfileForm />;
  // }

  return (
    <div>
      <Container
        style={{
          paddingLeft: '0.4em',
          paddingRight: '0.4em',
          height: '80vh',
        }}
      >
        {renderedForm}
      </Container>
    </div>
  );
};
export default EditSuperAdminProfile;
